// extracted by mini-css-extract-plugin
export default {"errorMessage":"createEmployee_errorMessage__Ya-8Z","inputError":"createEmployee_inputError__oeATF"};